import React from "react";
import { getThumbnailUrl } from "util/mediaUtil";
import Icon from "components/Icon";
import styles from "components/MediaAvatar.css";

const MediaAvatar = ({ children, className, media, ...props }) => {
  const thumbnailUrl = getThumbnailUrl(media);

  return (
    <div
      className={`${styles.avatar} ${className || ""}`}
      style={{
        backgroundImage: `url(${thumbnailUrl})`,
      }}
      {...props}
    >
      {media.type === "AUDIO" &&
        !thumbnailUrl && <Icon className={styles.audioIcon} value="audio" />}
      {children}
    </div>
  );
};

export default MediaAvatar;
